import SpinnerPage from "./SpinnerPage";

export default SpinnerPage;
